<header class="Header-mobile Header-mobile--spectrum">
  <div class="Header-container">
    <h1>
      <b>spectrum</b><br>
      database
    </h1>
    <a (click)="analyticsService.pushEvent('toLicencesMobile')" routerLink='/' class="Button Button--blue Button--home Button--licences"></a>
    <a (click)="analyticsService.pushEvent('toAwardsMobile')" routerLink='/awards/' class="Button Button--blue Button--home Button--awards"></a>
    <!-- <a (click)="analyticsService.pushEvent('toReportsMobile')" routerLink='/reports/upcoming' class="Button Button--blue Button--home Button--reports"></a> -->
    <div class="Filters-mobileButton">
      <button class="Button Button--blue" (click)="filterService.openMobileFilterOnClick()"><span>Filters</span></button>
    </div>
    <div class="OpenMobileMenu" (click)="openMobileMenuOnClick()"></div>
  </div>
  <div class="Header-blackOverlay" (click)="closeMobileMenuOnClick()" [ngClass]="mobileMenuIsOpen ? 'Header-blackOverlay--active' : ''"></div>
  <div class="Header-menu" [ngClass]="mobileMenuIsOpen ? 'Header-menu--active' : ''">
    <header>
      <ul class="SocialMenu">
        <li class="Social Social--twitter"><a href="https://twitter.com/CullenInt/" target="_blank"(click)="closeMobileMenuOnClick()"></a></li><!--
     --><li class="Social Social--linkedin"><a href="https://www.linkedin.com/company/cullen-international/" target="_blank"(click)="closeMobileMenuOnClick()"></a></li>
      </ul>
      <div class="CloseMobileMenu" (click)="closeMobileMenuOnClick()"></div>
      <div class="MyCullen">
        <img class="LogoCullen" src="assets/images/logo-cullen-rounded.png" alt="Cullen International">
        <h2 *ngIf="!user?.partialAuth">{{ user?.name }}</h2>
      </div>
    </header>
    <ul class="Navigation">
      <li>
        <a routerLink='/about/' (click)="closeMobileMenuOnClick()">About</a>
      </li>
      <li  *ngIf="!user?.partialAuth">
        <a [href]="getMyCullenUrl()" target="_blank" (click)="closeMobileMenuOnClick()">My Cullen</a>
        <ul>
          <li><a href="/product/profile/" (click)="closeMobileMenuOnClick()">Change password</a></li>
          <li><a (click)="logout()">Sign out</a></li>
        </ul>
      </li>
      <li  *ngIf="user?.partialAuth">
        <a [href]="getMyCullenUrl()" target="_blank" (click)="closeMobileMenuOnClick()">My Cullen</a>
        <a href="/login" (click)="closeMobileMenuOnClick()">Login</a>
      </li>
    </ul>
    <!-- CURRENCIES -->
    <div class="Currency FormElement FormElement--noMargin">
      <h3>Currency:</h3>
      <div class="CustomRadio CustomRadio--inline">
        <input type="radio" id="eurosMobile" name="currencyMobile" value="EUR" [(ngModel)]="currency" (click)="currencyService.setCurrency('EUR')">
        <label for="eurosMobile">€</label>
      </div>
      <div class="CustomRadio CustomRadio--inline">
        <input type="radio" id="dollarsMobile" name="currencyMobile" value="USD" [(ngModel)]="currency" (click)="currencyService.setCurrency('USD')">
        <label for="dollarsMobile">$</label>
      </div>
    </div>
  </div>
</header>
<header class="Header-desktop Header-desktop--spectrum">
  <span class="Anchor"></span>
  <div class="Wrap">
    <h1 class="MainTitle MainTitle--noMargin"><b>spectrum</b> database</h1>
    <nav>
      <ul class="Navigation" >
        <li class="NavItem">
          <a routerLink='/about/'>About</a>
        </li><!--
     --><li class="NavItem"><a [href]="getMyCullenUrl()" target="_blank">My Cullen</a></li><!--
     --><li class="Social Social--twitter"><a href="https://twitter.com/CullenInt/" target="_blank"></a></li><!--
     --><li class="Social Social--linkedin"><a href="https://www.linkedin.com/company/cullen-international/" target="_blank"></a></li><!--
     -->
     <li class="Profil" >
          <ul class="Submenu" *ngIf="!user?.partialAuth">
            <li class="LogoCullen">
              <img src="assets/images/logo-cullen-rounded.png" alt="Cullen International">
              <h2>{{user?.name }}</h2>
            </li>
            <li><a href="/product/profile/">Change password</a></li>
            <li><a (click)="logout()">Sign out</a></li>
          </ul>
          <ul class="Submenu" *ngIf="user?.partialAuth">
            <li class="LogoCullen">
              <img src="assets/images/logo-cullen-rounded.png" alt="Cullen International">
            </li>
            <li><a href="/login">Login</a></li>
          </ul>
        </li>
      </ul>

    </nav>
  </div>
</header>
